import { isString } from "./isString";

export const formatFunction = <T>(a: T | undefined): T => {
	let newObject: T = {} as T;

	for (let prop in a) {
		const val = a[prop];
		Object.defineProperty(newObject, prop, {
			enumerable: true,
			value: val ? (isString(val) ? (val.length ? val : null) : val) : null,
		});
	}

	return newObject;
};
